import request from '@/utils/request'

export function fetchList(data) {
  return request({
    url: '/CommissionBatchStatus/List',
    method: 'post',
    data,
  })
}

export function fetchLocalBatchStatus() {
  return new Promise(resolve => {
    resolve({ data: {
      items: [
        {
          id: 1,
          name: 'Calculating',
        }, {
          id: 2,
          name: 'Cancelled',
          value: 2,
          itemValue: 2,
          itemName: 'Cancelled',
          label: 'Cancelled',
        }, {
          id: 3,
          name: 'Completed',
          value: 3,
          itemValue: 3,
          itemName: 'Completed',
          label: 'Completed',
        }, {
          id: 4,
          name: 'Confirmed',
          value: 4,
          itemValue: 4,
          itemName: 'Confirmed',
          label: 'Confirmed',
        }],
    } })
  })
}
